import React from 'react';
import styles from './ActionFailed.module.css';
import useTheme from 'config/useTheme';

const ActionFailed = ({ text }) => {
    const { dark } = useTheme();
    return (
        <div className={`${styles.action_failed} ${dark ? styles.dark : ''}`}>
            <div className={styles.action_failed_container}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="48"
                    height="48"
                    fill="none"
                    viewBox="0 0 48 48"
                >
                    <path fill="#F5AEA9" d="M8 8h32v32H8z"></path>
                    <path
                        fill="url(#paint0_radial_152_2323)"
                        d="M24 1h32v32H24z"
                        transform="rotate(45 24 1)"
                    ></path>
                    <path
                        stroke="#fff"
                        strokeLinecap="round"
                        strokeWidth="2"
                        d="M18.12 30 30 18M29.88 30 18 18"
                    ></path>
                    <defs>
                        <radialGradient
                            id="paint0_radial_152_2323"
                            cx="0"
                            cy="0"
                            r="1"
                            gradientTransform="matrix(0 32 -32 0 40 1)"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop stopColor="#F48A82"></stop>
                            <stop offset="0.5" stopColor="#F44336"></stop>
                            <stop offset="1" stopColor="#C3362B"></stop>
                        </radialGradient>
                    </defs>
                </svg>
            </div>
            <span>{text}</span>
        </div>
    )
}

export default ActionFailed